import React from 'react';
import underImg from '../assets/images/under.jpg'

const UnderMaintenance = () => {
    return (
        <div className="splashImageContainer">
            <img alt="Jace Platform" src={underImg} className="splashImage" />
        </div>
    );
}

export default UnderMaintenance;
